import { Component, OnInit, Injector } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { ModelYearService } from '../../../mesc.service';
import { ModelYear } from '../../../../../shared/model';
import { MaintenanceService } from "../maintenance.service";

@Component({
  selector: 'model-year',
  templateUrl: './model-year.component.html',
  styleUrls: ['./model-year.component.css']
})
export class ModelYearComponent implements OnInit {
  private readonly maintenanceService: MaintenanceService;

  constructor(
    private ModelYearService: ModelYearService,
    private readonly injector: Injector,
  ) { 
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
  }

  isNew: boolean = false;
  editDataItem: ModelYear;
  editForm = new FormGroup({
    Year: new FormControl("", Validators.required),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),
  });

  columns: any[] = [
    {
      field: "Year",
      title: "Year",
    }
  ];

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    service: this.ModelYearService,
    fileName: 'modelYear.xlsx'
  }

  formDialog = {
    title: "Model year",
    formControls: [
      {
        type: "number",
        name: "Year",
        title: "Year*",
        readonly: "never",
      },
    ]
  }

  ngOnInit(): void {
    this.ModelYearService.query();
  }

  setModelHandler() {
    this.editDataItem = new ModelYear();
  }
}
